import { GET_PRESENTERS_KEY } from '@/state/presenters';
import { useQueryClient } from 'react-query';

export function useRefetchPresentersList() {
    const queryClient = useQueryClient();

    const refetchPresentersList = async () => {
        await queryClient.refetchQueries(GET_PRESENTERS_KEY);
    };

    return { refetchPresentersList };
}
